import * as angular from 'angular';

import { ComponentDefinition, IValueViewModel } from '../../../models';
import { StoreElement } from '../../../stateManagement';
import { StoreService } from '../../../services';

class CalculatedAnalysisStateController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;
    configuration: { guid: string };
    inputValuesQuality: any;
    guid: string;
    objectType: string;
    viewModels: { [guid: string]: IValueViewModel };

    static $inject = [
        '$stateParams',
        'storeService'
    ];

    constructor(private _$stateParams: angular.ui.IStateParamsService,
        private _storeService: StoreService) {
    }

    $onInit() {
        const guid = this._$stateParams['identifierGuid'];
        this.configuration = {
            guid: guid
        };
        this.guid = guid;
        this.objectType = 'calculated';
        this.inputValuesQuality = { configuration: { type: 'identifier', guid: guid } };
        this._storeService.register(store => {
            this.viewModels = store.valueViewModels.dictionary;
        }, [StoreElement.ValueViewModels]);
    }
}

export const wtCalculatedAnalysisState: ComponentDefinition = {
    componentId: 'wtCalculatedAnalysisState',
    controller: CalculatedAnalysisStateController,
    template: require('./calculatedAnalysisState.component.html'),
    controllerAs: 'vm',
    bindings: {

    }
};
